import { defaultJASBoardData } from '../../../../backend/config/classifiers/defaults/DefaultJASBoardData';
import { jasBoardSchema } from '../../../../backend/config/classifiers/types';
import { allowManageCredentialingClassifiers } from '../../../../backend/features/permissions';
import { updatePersonCredentialsByFilter } from '../../../../backend/features/person-credentials';
import { featureEnabled } from '../../../../backend/utils';
import { AuthError } from '@juvare/platform-app/App';
import { defineClassifierEntity, transformClassifierColumns } from '@juvare/platform-sdk-react/backend/features/classifiers';
import { classifierColumns } from '@juvare/platform-sdk-react/backend/features/classifiers/shared';
import { defineColumns } from '@juvare/platform-shared/features/storage';
export const jasBoardEntityName = 'jasBoard';
const jasBoardColumns = defineColumns(Object.assign(Object.assign({}, classifierColumns), { search: {
        type: 'full-text-search-required',
        language: 'english',
    }, verificationInterval: {
        type: 'number',
    }, outOfDateAfter: {
        type: 'number',
    }, escapeNonNumericCharacters: {
        type: 'boolean',
    }, escapeLeadingZeros: {
        type: 'boolean',
    } }));
export function defineJasBoardClassifier() {
    return defineClassifierEntity({
        entity: {
            version: 6,
            columns: jasBoardColumns,
            onMigrate: (params) => params.oldData,
            onTransformColumns: (_context, params) => {
                return Object.assign(Object.assign({}, transformClassifierColumns(params)), { verificationInterval: params.data.verificationInterval, outOfDateAfter: params.data.outOfDateAfter, search: [params.data.name, params.data.status].join(' '), escapeNonNumericCharacters: params.data.escapeNonNumericCharacters, escapeLeadingZeros: params.data.escapeLeadingZeros });
            },
            onChangeSync: (context) => {
                context.invalidateAppState('jasBoards');
            },
            onScheduleChangedAsync: (context) => {
                if (featureEnabled(context, 'credential')) {
                    return true;
                }
                return false;
            },
            onChangedAsync: (context, params) => {
                var _a;
                if (params.action === 'update' && (params.prevData.status === 'active' || params.data.status === 'active')) {
                    // License status might need to change
                    const affectedOccupationIds = [];
                    for (const [occupationId, occupation] of Object.entries(context.appState.occupations)) {
                        if ((_a = occupation === null || occupation === void 0 ? void 0 : occupation.credentials) === null || _a === void 0 ? void 0 : _a.find((oc) => oc.jasBoardId === params.id)) {
                            affectedOccupationIds.push(occupationId);
                        }
                    }
                    updatePersonCredentialsByFilter(context, {
                        column: 'occupationIds',
                        op: 'contains',
                        value: affectedOccupationIds,
                    });
                }
            },
            onAnonymousAuthList: (_appState, response) => response,
            onAuthPost: (_appState, userState) => {
                if (!allowManageCredentialingClassifiers(userState)) {
                    throw new AuthError('Unauthorized');
                }
            },
        },
        defaultData: defaultJASBoardData,
        publicData: true,
    }, jasBoardSchema);
}
